import { render, staticRenderFns } from "./KSwitch.vue?vue&type=template&id=2f413f23&"
import script from "./KSwitch.vue?vue&type=script&lang=js&"
export * from "./KSwitch.vue?vue&type=script&lang=js&"
import style0 from "./KSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports